import classNames from 'classnames'
import React from 'react'
import { GridColumnProps } from './GridColumn.d'

const GridColumn = ({
  columnStart = [],
  columnEnd = [],
  columnSpan = [],
  classes,
  children
}: GridColumnProps) => {
  const containerCss = classNames(
    classes,
    { [columnSpan.join(' ')]: columnSpan },
    { [columnStart.join(' ')]: columnStart },
    { [columnEnd.join(' ')]: columnEnd }
  )

  return (
    <div className={containerCss} data-testid='GridColumn'>
      {children}
    </div>
  )
}

export default GridColumn
